"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2161],{

/***/ 53839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ client; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87066);
/* harmony import */ var _constants_urls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26854);


const client = axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].create */ .Z.create({
    baseURL: _constants_urls__WEBPACK_IMPORTED_MODULE_0__/* ["default"].APP */ .Z.APP,
    headers: {
        "Content-Type": "application/json"
    }
});


/***/ }),

/***/ 41677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ LikeButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(10708);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./api/config.ts
var config = __webpack_require__(53839);
;// CONCATENATED MODULE: ./api/services/reaction.service.ts

/**
 * Reaction Service
 *
 * This service is responsible for handling all requests under the tag "Reaction".
 */ const ReactionService = {
    /**
   * Create a new reaction
   * @param data the data to create the reaction with
   * @returns the created reaction
   */ post: async (data)=>{
        const request = await config/* client.post */.L.post("/reaction/reaction", data);
        return request.data;
    }
};

// EXTERNAL MODULE: ./styles/theme.ts
var theme = __webpack_require__(18102);
;// CONCATENATED MODULE: ./components/buttons/LikeButton/LikeButton.tsx






const LikeButton = (param)=>{
    let { entityId , entityType , likeCount , bgColor ="transparent" , strokeColor =theme/* COLORS.black.normal */.DM.black.normal , setLikesCount  } = param;
    const cookieName = "LIKES";
    const [counter, setCounter] = (0,react.useState)(likeCount);
    const [cookies, setCookie] = (0,useCookies/* default */.Z)([
        cookieName
    ]);
    const [liked, setLiked] = (0,react.useState)(false);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setCounter(likeCount);
        setLiked(checkIfLiked());
    // Reload the state when the entityId changes (e.g. when the user navigates to a different page)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        entityId
    ]);
    (0,react.useEffect)(()=>{
        setLiked(checkIfLiked());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cookies
    ]);
    const checkIfLiked = ()=>{
        let likedArr = cookies[cookieName];
        if (likedArr == null) {
            return false;
        }
        return likedArr.filter((item)=>item.entityType === entityType && item.entityId === entityId).length > 0;
    };
    const handleCookie = (isLiked)=>{
        let oldVal = cookies[cookieName];
        let arr = [];
        if (oldVal != null) {
            arr = oldVal;
        }
        let obj = {
            entityId,
            entityType
        };
        if (isLiked) {
            arr.push(obj);
        } else {
            arr = arr.filter((item)=>!(item.entityType === entityType && item.entityId === entityId));
        }
        const d = new Date();
        const expiryDate = new Date(d.setDate(d.getDate() + 100));
        setCookie(cookieName, JSON.stringify(arr), {
            path: "/",
            expires: expiryDate
        });
    };
    const handleClick = async ()=>{
        const cookiesEnabled = navigator.cookieEnabled;
        // If cookies are disabled, show an alert
        if (!cookiesEnabled) {
            alert("Cookies are disabled in your browser. Please enable cookies to use this feature.");
            return;
        }
        setIsLoading(true);
        let isLiked = !liked;
        try {
            const newLikeCount = await ReactionService.post({
                entityId,
                entityType,
                reactionType: isLiked ? "like" : "dislike"
            });
            setLikesCount ? setLikesCount(newLikeCount) : setCounter(newLikeCount);
            handleCookie(isLiked);
            setLiked(isLiked);
        } catch (error) {
            alert("Er ging iets fout bij het verwerken van jouw like. Probeer het later opnieuw.");
        } finally{
            setIsLoading(false);
        }
    };
    if (entityType && entityId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
            disabled: isLoading,
            className: "flex ".concat(isLoading ? "cursor-not-allowed opacity-50" : ""),
            onClick: handleClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiHeart */.$aX, {
                    className: liked ? "liked" : "",
                    size: 24,
                    fill: liked ? "red" : bgColor,
                    stroke: liked ? "red" : strokeColor
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "font-avenir ml-[5px] text-[16px] font-light md:text-[18px]",
                    style: {
                        color: strokeColor
                    },
                    children: setLikesCount ? likeCount : counter
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {});
    }
};


/***/ }),

/***/ 26150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TagList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./components/buttons/Tag/Tag.tsx
var Tag = __webpack_require__(44831);
;// CONCATENATED MODULE: ./utils/horizontalScroll.ts
const updateArrows = function(element, rightArrow, leftArrow) {
    let delay = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, step = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    setTimeout(()=>{
        var _element_scrollLeft;
        const scrollLeft = (_element_scrollLeft = element === null || element === void 0 ? void 0 : element.scrollLeft) !== null && _element_scrollLeft !== void 0 ? _element_scrollLeft : 0;
        var _element_offsetWidth;
        const offsetWidth = (_element_offsetWidth = element === null || element === void 0 ? void 0 : element.offsetWidth) !== null && _element_offsetWidth !== void 0 ? _element_offsetWidth : 0;
        var _element_scrollWidth;
        const scrollWidth = (_element_scrollWidth = element === null || element === void 0 ? void 0 : element.scrollWidth) !== null && _element_scrollWidth !== void 0 ? _element_scrollWidth : 0;
        if (scrollLeft + step <= 0) {
            leftArrow === null || leftArrow === void 0 ? void 0 : leftArrow.classList.remove("active");
        } else if (scrollLeft + step > 0) {
            leftArrow === null || leftArrow === void 0 ? void 0 : leftArrow.classList.add("active");
        }
        if (scrollLeft + offsetWidth >= scrollWidth - 100) {
            rightArrow === null || rightArrow === void 0 ? void 0 : rightArrow.classList.remove("active");
            element === null || element === void 0 ? void 0 : element.classList.add("active");
        } else if (scrollLeft + offsetWidth - 100 <= scrollWidth) {
            element === null || element === void 0 ? void 0 : element.classList.remove("active");
            rightArrow === null || rightArrow === void 0 ? void 0 : rightArrow.classList.add("active");
        }
    }, delay);
};
const handleHorizontalScroll = (param)=>{
    let { element , step , rightArrow , leftArrow  } = param;
    if (element) {
        element.scrollTo({
            left: element.scrollLeft + step,
            behavior: "smooth"
        });
        updateArrows(element, rightArrow, leftArrow, 100, step);
    }
};

;// CONCATENATED MODULE: ./components/buttons/TagList/TagList.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: var(--color-white);\n  display: flex;\n  border-radius: 8px;\n  align-items: center;\n  justify-content: space-between;\n\n  -webkit-box-shadow: 0px 0px 5px 0px var(--color-black-shadow-30);\n  -moz-box-shadow: 0px 0px 5px 0px var(--color-black-shadow-30);\n  box-shadow: 0px 0px 5px 0px var(--color-black-shadow-30);\n\n  .right-arrow {\n    display: none;\n    cursor: pointer;\n  }\n\n  .right-arrow.active {\n    display: block;\n  }\n\n  .left-arrow {\n    display: none;\n    cursor: pointer;\n    transform: rotate(180deg);\n  }\n\n  .left-arrow.active {\n    display: block;\n  }\n\n  .outer {\n    position: relative;\n    overflow: hidden;\n    padding: 20px;\n    overflow-x: auto;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n\n    .inner {\n      display: flex;\n      gap: 16px;\n      overflow-x: auto;\n      width: 100%;\n\n      &.active .scroll-indicator {\n        display: none;\n      }\n\n      .tag {\n        text-transform: lowercase;\n        display: inline-block;\n\n        &:first-of-type {\n          margin-left: auto;\n        }\n\n        &:last-of-type {\n          margin-right: auto;\n        }\n\n        &:first-letter {\n          text-transform: uppercase;\n        }\n      }\n\n      .scroll-indicator {\n        position: absolute;\n        top: 0;\n        height: 100%;\n        width: 100px;\n        opacity: 0;\n        pointer-events: none;\n        border-radius: 8px;\n\n        &.indicator-left {\n          left: 0;\n          background: linear-gradient(\n            to right,\n            var(--color-white) 0%,\n            var(--color-white-opacity-0) 100%\n          );\n        }\n\n        &.indicator-right {\n          right: 0;\n          background: linear-gradient(\n            to left,\n            var(--color-white) 10%,\n            var(--color-white-opacity-0) 100%\n          );\n        }\n      }\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      &.scrolling-left .indicator-left {\n        opacity: 1;\n      }\n\n      &.scrolling-right .indicator-right {\n        opacity: 1;\n      }\n    }\n  }\n\n  @media (max-width: 767px) {\n    display: block;\n    padding: 16px 0;\n    .prefix {\n      padding: 0;\n    }\n\n    .right-arrow.active {\n      display: none;\n    }\n\n    .outer {\n      padding: 0;\n    }\n\n    .left-arrow.active {\n      display: none;\n    }\n\n    .scroll-indicator {\n      &.indicator-left {\n        left: 0;\n        background: none !important;\n      }\n\n      &.indicator-right {\n        right: 0;\n        background: none !important;\n      }\n    }\n\n    .outer .inner {\n      padding: 5px 0;\n    }\n\n    .hand-icon {\n      transform: rotate(90deg);\n      margin-top: 0px !important;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}





const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bea1c9a7-0"
})(_templateObject());
function TagList(param) {
    let { prefix , suffix , tags , selected , onSelect  } = param;
    const scrollRef = (0,react.useRef)(null);
    const leftArrow = (0,react.useRef)(null);
    const rightArrow = (0,react.useRef)(null);
    const isSelected = (id)=>selected === id;
    const noTagsSelected = selected === "" || selected === undefined;
    const tagRefs = (0,react.useRef)({});
    // Create a ref for each tag
    tags.forEach((tag)=>{
        if (!tagRefs.current[tag.id]) {
            tagRefs.current[tag.id] = /*#__PURE__*/ react.createRef();
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "block"
                },
                className: "prefix pl-[16px]",
                children: prefix
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: 81,
                    padding: "0px 30px 0 0px"
                },
                className: "left-arrow",
                onClick: ()=>{
                    handleHorizontalScroll({
                        element: scrollRef.current,
                        step: -400,
                        leftArrow: leftArrow.current,
                        rightArrow: rightArrow.current
                    });
                },
                id: "text",
                ref: leftArrow,
                children: suffix
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "outer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: scrollRef,
                    className: "inner scrolling-right",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "scroll-indicator indicator-left"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                            className: "tag",
                            isActive: noTagsSelected,
                            onClick: ()=>{
                                return onSelect === null || onSelect === void 0 ? void 0 : onSelect("");
                            },
                            style: {
                                backgroundColor: noTagsSelected ? "var(--color-teal)" : "transparent",
                                color: noTagsSelected ? "var(--color-white)" : "var(--color-black)",
                                border: "1px solid var(--color-teal)",
                                textTransform: "capitalize",
                                fontFamily: "Avenir",
                                marginLeft: "16px"
                            },
                            children: "Alles"
                        }, "everything"),
                        tags.map((tag)=>{
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                ref: tagRefs.current[tag.id],
                                className: "flex",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                                    className: "tag",
                                    isActive: isSelected(tag.id),
                                    onClick: ()=>{
                                        return onSelect === null || onSelect === void 0 ? void 0 : onSelect(isSelected(tag.id) ? "" : tag.id);
                                    },
                                    style: {
                                        backgroundColor: isSelected(tag.id) ? "var(--color-teal)" : "transparent",
                                        color: isSelected(tag.id) ? "var(--color-white)" : "var(--color-black)",
                                        border: "1px solid var(--color-teal)",
                                        fontFamily: "Avenir",
                                        textTransform: "none"
                                    },
                                    children: tag.name
                                }, tag.id)
                            }, tag.id);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "scroll-indicator indicator-right"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: 77,
                    padding: "0px 30px 0 4px"
                },
                className: "right-arrow active",
                onClick: ()=>{
                    handleHorizontalScroll({
                        element: scrollRef.current,
                        step: 400,
                        rightArrow: rightArrow.current,
                        leftArrow: leftArrow.current
                    });
                },
                ref: rightArrow,
                children: suffix
            })
        ]
    });
}


/***/ }),

/***/ 11504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ForumPost; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61121);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50066);
/* harmony import */ var _components_buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19499);
/* harmony import */ var _components_buttons_LikeButton_LikeButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41677);
/* harmony import */ var _components_buttons_Tag_Tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44831);
/* harmony import */ var _components_typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65906);
/* harmony import */ var _utils_parseDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(55214);
/* harmony import */ var _utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46290);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* border: 1px solid ",
        "; */\n  border-radius: 8px;\n  padding: 24px;\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  border: 2px solid var(--color-teal);\n\n  &.main-forum {\n    background-color: ",
        " !important;\n\n    width: 100%;\n  }\n\n  height: 100%;\n\n  p {\n  }\n\n  > div:last-child {\n    display: flex;\n    flex-direction: column;\n\n    > div {\n      height: 100%;\n    }\n  }\n\n  .forum-tag {\n    color: var(--color-pink) !important;\n  }\n\n  &:hover {\n    // background-color: ",
        ";\n    border: 2px solid var(--color-teal);\n    color: white;\n\n    main-forum .forum-tag {\n      background: var(--color-white) !important;\n    }\n\n    .main-forum .content {\n      .forum-tags {\n        span {\n          background-color: ",
        ';\n          color: white;\n          font-weight: 400;\n          font-size: 18px;\n          font-family: "Fjalla One";\n        }\n      }\n    }\n  }\n\n  header {\n    display: flex;\n    align-items: center;\n    gap: 30px;\n    margin-bottom: 30px;\n\n    p,\n    h4 {\n      color: white;\n    }\n  }\n\n  .footer-button-section {\n    position: absolute;\n    height: unset;\n    bottom: 24px;\n    width: 100%;\n    padding-right: 48px;\n  }\n\n  @media (max-width: 900px) {\n    .footer-button-section {\n      position: unset;\n      padding-right: 0;\n    }\n  }\n\n  @media (min-width: 768px) and (max-width: 900px) {\n    .footer-button-section {\n      position: absolute;\n      padding-right: 48px;\n    }\n  }\n\n  .content {\n    margin-bottom: 30px;\n    font-size: ',
        ';\n\n    @media (max-width: 768px) {\n      margin-top: 0px;\n    }\n\n    color: var(--color-black);\n\n    > div {\n      display: flex;\n      gap: 8px;\n      margin-bottom: 30px;\n    }\n\n    .forum-tags {\n      height: 48px;\n      overflow: hidden;\n\n      span {\n        padding: 8px 10px;\n        background-color: white;\n        border: none;\n        height: 41px;\n        color: var(--color-teal);\n        font-weight: 400;\n        font-size: 18px;\n        font-family: "Fjalla One";\n      }\n    }\n  }\n\n  .forum-footer {\n    position: absolute;\n    bottom: 24px;\n    width: calc(100% - 48px);\n  }\n\n  footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: var(--color-black);\n\n    .geplaatst {\n      color: var(--color-black);\n    }\n\n    .icon-wrapper {\n      display: flex;\n\n      gap: 5.55px;\n\n      svg {\n        cursor: pointer;\n      }\n    }\n\n    p {\n      margin: 0;\n    }\n  }\n\n  .title {\n    font-size: 32px !important;\n    font-weight: 400;\n    margin-bottom: 0 !important;\n    margin-top: 0 !important;\n  }\n\n  &.main-forum.forum-post.forum-list {\n    .forum-tags span {\n      color: var(--color-white);\n    }\n\n    .back-act {\n      background: var(--color-teal) !important;\n      border: none !important;\n    }\n  }\n\n  &.forum-detail {\n    background-color: var(--color-teal) !important;\n\n    h4,\n    p,\n    .content {\n      color: var(--color-white) !important;\n    }\n\n    .content {\n      margin-top: 30px;\n      margin-bottom: 60px;\n    }\n\n    .forum-footer {\n      bottom: unset;\n      position: unset;\n      margin-top: 24px;\n      width: unset;\n\n      footer {\n        bottom: 24px;\n        position: absolute;\n        width: calc(100% - 48px);\n\n        svg {\n          stroke: var(--color-white);\n        }\n\n        .comments svg path {\n          fill: var(--color-white);\n        }\n      }\n    }\n  }\n\n  .custom_form_tags {\n    height: 170px;\n    overflow-y: auto !important;\n  }\n\n  @media (max-width: 767px) {\n    .title {\n      font-size: 24px !important;\n    }\n  }\n\n  @media ',
        " {\n    .content {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}










const StyledForumPost = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].article.withConfig */ .ZP.article.withConfig({
    componentId: "sc-5106539c-0"
})(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.normal;
}, (param)=>{
    let { theme , showButton  } = param;
    return showButton ? theme.colors.secondary.normal : theme.colors.primaryReversed.normal;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.normal;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.secondary.normal;
}, (param)=>{
    let { theme  } = param;
    return theme.fontSizes.p.desktop;
}, (param)=>{
    let { theme  } = param;
    return theme.breakpoints.tablet;
}, (param)=>{
    let { theme  } = param;
    return theme.fontSizes.p.mobile;
});
function ForumPost(param) {
    let { id , button , title , content , age , postDate , truncateContent =true , showButton =false , buttonUrl ="" , tags =[] , tagsBack =[] , tagsHome =[] , tagsHomeBack =[] , name , className , likesCount =0 , commentsCount , setLikesCount , isBackSide , isHomepage  } = param;
    const ComponentTag = showButton ? "a" : "div";
    const props = showButton ? {
        href: buttonUrl
    } : {};
    const hasTags = ()=>{
        return tags.length > 0 || tagsBack.length > 0 || tagsHome.length > 0 || tagsHomeBack.length > 0;
    };
    const ForumFooterWithButtons = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "footer-button-section mt-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "mb-[16px] flex justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "icon-wrapper mr-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "likes flex gap-1",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_LikeButton_LikeButton__WEBPACK_IMPORTED_MODULE_4__/* .LikeButton */ .d, {
                                            likeCount: likesCount,
                                            entityId: id !== null && id !== void 0 ? id : "",
                                            entityType: "forum",
                                            strokeColor: "var(--color-white)",
                                            setLikesCount: setLikesCount
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "comments flex gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_9__/* .BiMessage */ .GQN, {
                                                size: 24
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "font-avenir text-[16px] font-light md:text-[18px]",
                                                children: commentsCount
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: postDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "geplaatst font-avenir text-lg font-light italic",
                                children: (0,_utils_parseDate__WEBPACK_IMPORTED_MODULE_10__/* .parseDate */ .sG)(postDate)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    style: {
                        backgroundColor: "white",
                        color: "var(--color-teal)",
                        fontWeight: "400",
                        fontSize: "18px",
                        border: "1px solid var(--color-white)"
                    },
                    href: "".concat(buttonUrl, "#comment"),
                    children: "Laat een reactie achter"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    style: {
                        backgroundColor: "var(--color-teal)",
                        color: "var(--color-white) !important",
                        fontWeight: "400",
                        fontSize: "18px",
                        border: "1px solid var(--color-white)"
                    },
                    href: buttonUrl,
                    className: "forum-secondary-button",
                    children: "Lees verder"
                })
            ]
        });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledForumPost, {
        style: truncateContent ? {
            minHeight: 540
        } : {},
        showButton: showButton,
        className: "main-forum ".concat(className, " flex flex-col overflow-hidden"),
        children: [
            !!title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_typography__WEBPACK_IMPORTED_MODULE_6__.H4, {
                variant: "bold",
                className: "title font-[32px] ".concat(truncateContent ? "line-clamp-2" : ""),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                className: "mt-[5px] text-lg font-extrabold ".concat(isHomepage || isBackSide ? "text-white" : "text-black"),
                children: [
                    name,
                    ", ",
                    (age === null || age === void 0 ? void 0 : age.includes("jaar")) ? age : "".concat(age, " jaar")
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: "content text-[16px] md:text-[18px]",
                    children: [
                        hasTags() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "forum-tags my-[14px] flex flex-wrap",
                            children: [
                                tags.length > 0 && tags.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_Tag_Tag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        variant: "dark",
                                        size: "m",
                                        style: {
                                            backgroundColor: "var(--color-teal)",
                                            borderColor: "var(--color-teal)"
                                        },
                                        children: item
                                    }, item)),
                                tagsBack.length > 0 && tagsBack.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_Tag_Tag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        variant: "light",
                                        size: "m",
                                        style: {
                                            backgroundColor: "var(--color-white)",
                                            border: "2px solid var(--color-teal)",
                                            color: "var(--color-teal)"
                                        },
                                        children: item
                                    }, item)),
                                tagsHome.length > 0 && tagsHome.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_Tag_Tag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        variant: "dark",
                                        size: "m",
                                        style: {
                                            backgroundColor: "var(--color-white)",
                                            borderColor: "var(--color-teal)",
                                            color: "var(--color-pink)"
                                        },
                                        children: item
                                    }, item)),
                                tagsHomeBack.length > 0 && tagsHomeBack.map((item)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_Tag_Tag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        variant: "light",
                                        size: "m",
                                        style: {
                                            backgroundColor: "var(--color-white)",
                                            border: "2px solid var(--color-teal)",
                                            color: "var(--color-teal)"
                                        },
                                        children: item
                                    }, item))
                            ]
                        }),
                        !hasTags() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "h-[10px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "custom_forum_tags ".concat(truncateContent ? isBackSide ? "line-clamp-6 md:line-clamp-4" : "line-clamp-11 md:line-clamp-9" : ""),
                            children: (0,_utils_parseHTMLtoReact__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(content)
                        })
                    ]
                })
            }),
            button ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: isHomepage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ForumFooterWithButtons, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "forum-footer md:bottom-[180px] md:w-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ForumFooterWithButtons, {})
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ComponentTag, {
                ...props,
                className: "forum-footer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("footer", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "icon-wrapper mr-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "likes flex gap-1",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_buttons_LikeButton_LikeButton__WEBPACK_IMPORTED_MODULE_4__/* .LikeButton */ .d, {
                                            likeCount: likesCount,
                                            entityId: id !== null && id !== void 0 ? id : "",
                                            entityType: "forum",
                                            setLikesCount: setLikesCount
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "comments flex gap-1",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_9__/* .BiMessage */ .GQN, {
                                                size: 24
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                className: "font-avenir text-[16px] font-light md:text-[18px]",
                                                children: commentsCount
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            children: postDate && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                className: "geplaatst font-avenir text-right text-lg font-light italic",
                                children: (0,_utils_parseDate__WEBPACK_IMPORTED_MODULE_10__/* .parseDate */ .sG)(postDate)
                            })
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 72552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./components/buttons/Tag/Tag.tsx
var Tag = __webpack_require__(44831);
// EXTERNAL MODULE: ./components/form/HelperText.tsx
var HelperText = __webpack_require__(58969);
// EXTERNAL MODULE: ./components/icons/ChevronDownFilled/ChevronDownFilled.tsx
var ChevronDownFilled = __webpack_require__(16108);
// EXTERNAL MODULE: ./components/icons/ChevronUpFilled/ChevronUpFilled.tsx
var ChevronUpFilled = __webpack_require__(8102);
// EXTERNAL MODULE: ./components/icons/IconWrapper/IconWrapper.tsx
var IconWrapper = __webpack_require__(6129);
// EXTERNAL MODULE: ./styles/theme.ts
var theme = __webpack_require__(18102);
// EXTERNAL MODULE: ./utils/eventHandlers.ts
var eventHandlers = __webpack_require__(79226);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
;// CONCATENATED MODULE: ./components/form/Dropdown/Dropdown.styled.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n          .selectBox {\n            border: 2px solid var(--color-red) !important;\n          }\n\n          footer {\n            svg path {\n              fill: var(--color-red);\n            }\n\n            p {\n              color: var(--color-red);\n            }\n          }\n        "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  position: relative;\n  height: 100%;\n  justify-content: space-between;\n\n  select {\n    position: absolute;\n    left: -999999px;\n  }\n\n  label {\n    margin-bottom: 16px;\n\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 160%;\n    color: var(--color-black);\n  }\n\n  .selectBox {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 1px solid;\n    background-color: white;\n    width: 100%;\n    border-radius: 8px;\n\n    display: flex;\n    align-items: center;\n    padding: 10px 16px;\n\n    span {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 160%;\n      color: var(--color-input-placeholder);\n    }\n\n    &.open {\n      border-radius: 8px 8px 0 0;\n    }\n  }\n\n  .selectItems {\n    border: 1px solid;\n    border-top-width: 0;\n    background-color: white;\n    width: 100%;\n    border-radius: 0 0 8px 8px;\n    position: absolute;\n    z-index: 999;\n    display: flex;\n    flex-direction: column;\n    padding: 6.18px 0 10px 0;\n\n    button {\n      font-weight: 400;\n      font-size: 18px;\n      line-height: 160%;\n      width: 100%;\n      border: none;\n      outline: 0;\n      text-align: left;\n      background-color: white;\n      padding: 0;\n      padding: 0 16px;\n\n      color: var(--color-black);\n\n      &:hover {\n        background-color: ",
        ";\n        color: ",
        ";\n      }\n    }\n  }\n\n  footer {\n    display: flex;\n    align-items: center;\n    margin-top: 13.5px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}

const DropdownWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2b76a8d8-0"
})(_templateObject1(), (param)=>{
    let { theme  } = param;
    return theme.colors.primary.normal;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.white;
}, (param)=>{
    let { hasError  } = param;
    return hasError ? (0,styled_components_browser_esm/* css */.iv)(_templateObject()) : null;
});

;// CONCATENATED MODULE: ./components/form/Dropdown/Dropdown.tsx











function Dropdown(param) {
    let { iconLeft , options , label , disabled , helperText , labelClass , register , name , required , requiredSignColor , onChange , placeholder ="Kies een optie" , placeholderClass , hasError =false , borderColor ="primary" , multi =false , extraDesc ="" , value , chevronColor ="white" , enablePlaceholderStyling =false , defaultValue , ...rest } = param;
    var _options_find;
    const inputRef = (0,react.useRef)(null);
    const wrapperRef = (0,react.useRef)(null);
    const { colors  } = (0,styled_components_browser_esm/* useTheme */.Fg)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [selectedSingle, setSelectedSingle] = (0,react.useState)(null);
    const [selectedMulti, setSelectedMulti] = (0,react.useState)([]);
    const formRegister = register ? register(name, {
        required: required ? "Dit veld is verplicht" : null
    }) : {};
    const handleInputFocus = ()=>{
        var _inputRef_current;
        inputRef === null || inputRef === void 0 ? void 0 : (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    };
    const handleOptionClick = (option)=>{
        if (!multi) {
            handleSelect(option);
            return;
        }
        handleAddSelectMulti(option);
    };
    const handleSelect = (option)=>{
        setSelectedSingle(option);
        if (formRegister) {
            var _formRegister_onChange;
            formRegister === null || formRegister === void 0 ? void 0 : (_formRegister_onChange = formRegister.onChange) === null || _formRegister_onChange === void 0 ? void 0 : _formRegister_onChange.call(formRegister, {
                target: {
                    name,
                    value: option.value
                }
            });
        }
        if (onChange) onChange(option.value);
        setIsOpen(()=>false);
    };
    const handleAddSelectMulti = (option)=>{
        let selectList = [
            ...selectedMulti
        ];
        const found = selectList.filter((item)=>item.value === option.value);
        if (found[0]) {
            selectList = selectList.filter((item)=>item.value !== option.value);
        } else {
            selectList.push(option);
        }
        if (formRegister) {
            var _formRegister_onChange;
            formRegister === null || formRegister === void 0 ? void 0 : (_formRegister_onChange = formRegister.onChange) === null || _formRegister_onChange === void 0 ? void 0 : _formRegister_onChange.call(formRegister, {
                target: {
                    name,
                    value: selectList.map((item)=>item.value)
                }
            });
        }
        if (onChange) onChange(option.value);
        setSelectedMulti(selectList);
    };
    const handleRemoveItem = (id)=>{
        let selectList = [
            ...selectedMulti
        ].filter((item)=>item.value !== id);
        setSelectedMulti(selectList);
    };
    const generateOptionActiveStyle = (option)=>{
        const found = selectedMulti.filter((item)=>item.value === option.value);
        if (multi && found[0]) {
            return {
                backgroundColor: colors.primary.normal
            };
        }
        return {};
    };
    (0,eventHandlers/* useOnClickOutsideEl */.N)(wrapperRef, ()=>{
        setIsOpen(false);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
        hasError: hasError,
        onClick: handleInputFocus,
        ref: wrapperRef,
        children: [
            !!label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                style: {
                    fontFamily: "Avenir"
                },
                className: "".concat(labelClass, " text-white"),
                children: [
                    label,
                    " ",
                    required && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            color: requiredSignColor || theme/* COLORS.tertiary.normal */.DM.tertiary.normal
                        },
                        children: "*"
                    }),
                    extraDesc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "extra-desc",
                        children: [
                            "(",
                            extraDesc,
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                multiple: multi,
                                ref: inputRef,
                                placeholder: placeholder,
                                disabled: disabled,
                                onBlur: ()=>setIsOpen(()=>false),
                                ...formRegister,
                                ...rest,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: ""
                                    }),
                                    options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: option.value,
                                            children: option.name
                                        }, option.value))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "selectBox ".concat(isOpen ? "open" : ""),
                                style: {
                                    borderColor: colors[borderColor].normal,
                                    fontFamily: "Avenir"
                                },
                                onClick: ()=>setIsOpen((state)=>!state),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        style: {
                                            fontFamily: "Avenir"
                                        },
                                        children: [
                                            !!iconLeft && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper/* default */.Z, {
                                                style: {
                                                    marginRight: 10
                                                },
                                                children: iconLeft
                                            }),
                                            !multi ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    fontFamily: "Avenir",
                                                    minHeight: "1.5rem"
                                                },
                                                className: enablePlaceholderStyling ? "".concat(!value ? "text-input-placeholder" : "text-input") : placeholderClass,
                                                children: defaultValue !== undefined && defaultValue.name !== "" ? defaultValue.name : (value == null || value === "" ? selectedSingle === null || selectedSingle === void 0 ? void 0 : selectedSingle.name : (_options_find = options.find((option)=>option.value === value)) === null || _options_find === void 0 ? void 0 : _options_find.name) || placeholder
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    fontFamily: "Avenir"
                                                },
                                                className: placeholderClass,
                                                children: placeholder
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "end"
                                        },
                                        children: !isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownFilled/* default */.Z, {
                                            color: borderColor,
                                            fill: chevronColor
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronUpFilled/* default */.Z, {
                                            color: borderColor,
                                            fill: chevronColor
                                        })
                                    })
                                ]
                            }),
                            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "selectItems",
                                style: {
                                    borderColor: colors[borderColor].normal,
                                    maxHeight: "400px",
                                    overflow: "auto"
                                },
                                children: options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        style: generateOptionActiveStyle(option),
                                        onClick: ()=>handleOptionClick(option),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                option.icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex w-[16px] justify-center align-middle",
                                                    children: option.icon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    style: {
                                                        marginLeft: option.icon ? "8px" : ""
                                                    },
                                                    children: option.name
                                                })
                                            ]
                                        })
                                    }, option.value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HelperText/* default */.Z, {
                        text: helperText
                    })
                ]
            }),
            selectedMulti.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[16px] flex flex-wrap gap-[8px]",
                children: selectedMulti.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* default */.Z, {
                        size: "m",
                        onClick: ()=>handleRemoveItem(item.value),
                        children: item.name
                    }, index))
            })
        ]
    });
}


/***/ }),

/***/ 16108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronDownFilled; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function ChevronDownFilled(param) {
    let { fill ="var(--color-white)" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: 17,
        height: 12,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.892 11.434a1 1 0 0 1-1.6 0L.287 2.1a1 1 0 0 1 .8-1.6h14.011a1 1 0 0 1 .8 1.6l-7.006 9.334Z",
            fill: fill || "var(--color-black)"
        })
    });
}


/***/ }),

/***/ 33080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronRight; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);



function ChevronRight(param) {
    let { color ="primary" , ...props } = param;
    const { colors  } = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 38,
        height: 38,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: 19,
                cy: 19,
                r: 19,
                fill: colors[color].normal
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "var(--color-white)",
                d: "M16.678 11.766a1.102 1.102 0 0 0-1.55 0l-.335.33a1.102 1.102 0 0 0 0 1.568l4.597 4.553a1.102 1.102 0 0 1 0 1.566l-4.598 4.553a1.102 1.102 0 0 0 0 1.567l.336.331c.43.425 1.12.425 1.55 0l6.528-6.45a1.103 1.103 0 0 0 0-1.568l-6.528-6.45Z"
            })
        ]
    });
}


/***/ }),

/***/ 8102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronUpFilled; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function ChevronUpFilled(param) {
    let { fill ="var(--color-white)" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: 17,
        height: 12,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M7.692.566a1 1 0 0 1 1.6 0L16.297 9.9a1 1 0 0 1-.8 1.6H1.487a1 1 0 0 1-.8-1.6L7.692.566Z",
            fill: fill
        })
    });
}


/***/ }),

/***/ 55214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZE": function() { return /* binding */ calculateDaysLeft; },
/* harmony export */   "hh": function() { return /* binding */ formatVolunteerTrainingDaysList; },
/* harmony export */   "sG": function() { return /* binding */ parseDate; },
/* harmony export */   "vX": function() { return /* binding */ formatEventDate; },
/* harmony export */   "xO": function() { return /* binding */ getDropdownItemById; }
/* harmony export */ });
/* unused harmony exports parseDateRelative, parseDateWithTime */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11510);

function parseDateRelative(date) {
    if (!date) return;
    return formatRelative(date, Date.now());
}
function parseDateWithTime(date) {
    if (!date) return;
    return format(new Date(date), "dd-MM-yyy hh:mm:ss");
}
function parseDate(date) {
    if (!date) return;
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(date, "dd-MM-yyy");
}
const formatVolunteerTrainingDaysList = (volunteerTrainingDays)=>{
    return volunteerTrainingDays.map((trainingDay)=>{
        const dateObj = new Date(trainingDay.date);
        const formattedDate = "".concat(dateObj.toLocaleDateString("nl-NL", {
            weekday: "long",
            day: "numeric",
            month: "long"
        }), " om ").concat(dateObj.toLocaleTimeString("nl-NL", {
            hour: "2-digit",
            minute: "2-digit"
        }), " uur");
        return {
            name: "".concat(trainingDay.trainingTitle, " op ").concat(formattedDate),
            value: trainingDay.id
        };
    });
};
const getDropdownItemById = (volunteerTrainingDateId, volunteerTrainingDays)=>{
    // Format the list of volunteer training days
    const formattedList = formatVolunteerTrainingDaysList(volunteerTrainingDays);
    // Find the item with the matching ID
    return formattedList.find((item)=>item.value === volunteerTrainingDateId);
};
const calculateDaysLeft = (date)=>{
    const newDate = new Date(date);
    // Set the time to midnight for both dates to count only full days
    newDate.setHours(0, 0, 0, 0);
    // Create a new date for 'now' and set its time to midnight
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    // Calculate the difference in milliseconds between the target date and now
    const timeDifference = newDate.getTime() - now.getTime();
    // Calculate the number of days left, rounding down to the nearest whole number
    const daysLeft = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    return "over ".concat(daysLeft, " ").concat(daysLeft === 1 ? "dag" : "dagen");
};
const formatEventDate = (startDate, endDate)=>{
    const optionsDate = {
        day: "numeric",
        month: "long",
        year: "numeric"
    };
    const optionsTime = {
        hour: "2-digit",
        minute: "2-digit"
    };
    const start = new Date(startDate);
    const end = new Date(endDate);
    const formattedDate = start.toLocaleDateString("nl-NL", optionsDate);
    const formattedStartTime = start.toLocaleTimeString("nl-NL", optionsTime);
    const formattedEndTime = end.toLocaleTimeString("nl-NL", optionsTime);
    return "".concat(formattedDate, " om ").concat(formattedStartTime, " - ").concat(formattedEndTime);
};


/***/ }),

/***/ 38775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _constants_urls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26854);

const parseImageURL2 = function(imageID, size) {
    return imageID ? "".concat(_constants_urls__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CMSKIT */ .Z.CMSKIT, "/media/").concat(imageID, "?width=").concat(size !== null && size !== void 0 ? size : 700, "&quality=80") : "https://picsum.photos/".concat(size !== null && size !== void 0 ? size : 700);
};
/* harmony default export */ __webpack_exports__["Z"] = (parseImageURL2);


/***/ })

}]);